import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import React, { ReactNode } from 'react';
import { getWindow } from 'src/utilities/window';

const PRINT_FRAME_ID_PREFIX = 'print-frame';
export const PRINT_PREVIEW_DELAY = 250;

export interface IPrintContentProps {
  containerId: string;
  children: ReactNode;
  title?: string;
}

export default function PrintContent({
  containerId,
  children,
  title,
}: IPrintContentProps): JSX.Element {
  const window = getWindow();

  function createPrintIframe(): HTMLIFrameElement {
    const iFrameID = `${PRINT_FRAME_ID_PREFIX}-${Date.now()}`;
    const printFrame = window.document.createElement('iframe');
    printFrame.setAttribute('id', iFrameID);
    printFrame.setAttribute('name', iFrameID);
    printFrame.setAttribute('data-testid', 'print-iframe');
    printFrame.setAttribute(
      'style',
      'visibility: hidden; position: absolute; top: 0;'
    );
    return printFrame;
  }

  function printContent() {
    // Remove previous iframe if exists
    const existingIframe = window.document.querySelector(
      `[id^=${PRINT_FRAME_ID_PREFIX}]`
    );
    if (existingIframe) {
      window.document.body.removeChild(existingIframe);
    }

    const iFrame = createPrintIframe();
    const content = window.document.getElementById(containerId);

    document.body.appendChild(iFrame);

    const headTag = window.document.getElementsByTagName('head')[0];
    const sourceStylesTag = headTag.getElementsByTagName('style');
    const sourceLinkTag = headTag.getElementsByTagName('link');

    const pri = (iFrame as HTMLIFrameElement).contentWindow;

    pri.document.open();
    pri.document.write('<!DOCTYPE html>');
    pri.document.write('<html><head>');

    if (title) {
      pri.document.write(`<title>${title}</title>`);
    }

    pri.document.write('<meta charset="utf-8">');

    // Adding stylesheet links to the print frame
    Array.from(sourceLinkTag).forEach((link) => {
      if (link.rel === 'stylesheet') {
        pri.document.write(
          `<link rel="stylesheet" href="${link.href}" media="print" type="text/css"/>`
        );
      }
    });

    // Styled components generates styles into styles tags
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < sourceStylesTag.length; index++) {
      pri.document.write('<style>');
      pri.document.write(sourceStylesTag[index].innerText);
      pri.document.write('</style>');
    }

    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    // Added timeout because print preview would open before document could be built
    setTimeout(() => {
      pri.print();
    }, PRINT_PREVIEW_DELAY);
  }
  return (
    <Square data-testid="print-children-content" onClick={printContent}>
      {children}
    </Square>
  );
}
